<template>
  <div class="container">
    <!-- 面包屑 -->
    <ul class="bread-crumb">
      <li
        class="bread-crumb-item"
        v-for="item in filterMatchedRoutes"
        :key="item.name">
        {{ $t(item.meta.title) }}
        <AliIcon
          class="ali-icon"
          name="biaotijiantou">
        </AliIcon>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState('nav', ['matchedRoutes']),
    filterMatchedRoutes () {
      // 过滤掉没有title属性的路由
      const { matchedRoutes } = this
      return matchedRoutes.filter(item => item.meta && item.meta.title && !item.meta.hiddenTitle)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.container {
  .bread-crumb {
    display: flex;
    align-items: center;
    .bread-crumb-item {
      display: flex;
      align-items: center;
      // position: relative;
      font-size: 14px;
      color: #5A607F;
      line-height: 14px;
      // margin-right: 26px;
      // cursor: pointer;
      // &::after {
      //   position: absolute;
      //   top: 50%;
      //   right: -20px;
      //   transform: translateY(-50%);
      //   content: '';
      //   width: 0;
      //   height: 0;
      //   border: 5px solid;
      //   border-color: transparent transparent transparent #D7DBEC;
      //   cursor: initial;
      // }
      // &:last-child {
      //   margin-right: 0;
      //   &::after {
      //     display: none;
      //   }
      // }
      .ali-icon {
        width: 6px;
        height: 10px;
        margin: 0 10px;
      }
      &:last-child {
        .ali-icon {
          display: none;
        }
      }
    }
  }
}
</style>
